/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maple_Vast_Seal_GripInputs */

const en_maple_vast_seal_grip = /** @type {(inputs: Maple_Vast_Seal_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add one entry per feedback group`)
};

const de_maple_vast_seal_grip = /** @type {(inputs: Maple_Vast_Seal_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Feedback-Gruppe hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add one entry per feedback group" |
*
* @param {Maple_Vast_Seal_GripInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const maple_vast_seal_grip = /** @type {((inputs?: Maple_Vast_Seal_GripInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maple_Vast_Seal_GripInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maple_vast_seal_grip(inputs)
	return de_maple_vast_seal_grip(inputs)
});